@if (filterFieldsWithOptions$ | async; as filterFieldsWithOptions) {
  @if (optionStates$ | async; as optionStates) {
    <div class="gap-3 py-1.5 px-6 flex flex-row items-center flex-wrap" [class.hidden]="!optionStates.length">
      @for (filterFieldWithOptions of filterFieldsWithOptions; track filterFieldWithOptions) {
        <div class="flex flex-row items-center flex-wrap gap-1">
          @if (filterFieldWithOptions.translationKey) {
            <span class="font-main text-sm font-bold">
              {{ filterFieldWithOptions.translationKey | translate }}
            </span>
          }

          @for (optionState of filterFieldWithOptions.options; track $index) {
            <app-selected-fitler-option-chip
              [fieldId]="optionState.fieldId"
              [optionId]="optionState.id"
            ></app-selected-fitler-option-chip>
          }
        </div>
      }
      <ng-content></ng-content>
      <button
        data-test-id="reset-all-filters-button"
        class="flex items-center font-main text-lg text-white py-1 px-3 rounded-full bg-navy-80 hover:bg-navy-90 outline-none"
        (click)="resetAllFilters()"
      >
        {{ buildTranslationKey('clearFilters') | translate }}
      </button>
    </div>
  }
}
